import { addDaysLocal, diffDaysLocal } from '@fos/shared/time';
import { formatDateShort, plural } from '../../../lib/format';

/**
 * Termin zadania po ludzku (Figma 04 Zadania): „dziś”, „jutro”, „czw.” (w tym tygodniu), „12.10”,
 * „2 dni po terminie” (czerwony). Daty biznesowe "YYYY-MM-DD" w Europe/Warsaw.
 */

const WEEKDAYS = ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'] as const;

/** danger = po terminie (czerwony), warning = dziś (bursztynowy; lifting 17.10.2026), muted = reszta. */
export type DueTone = 'danger' | 'warning' | 'muted';

export interface DueInfo {
  text: string;
  tone: DueTone;
  overdue: boolean;
}

function weekday(date: string): number {
  const [y, m, d] = date.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay();
}

/** Opis terminu względem `today`. Zadanie gotowe nie jest „po terminie”. */
export function dueInfo(dueDate: string | null, today: string, opts: { done?: boolean } = {}): DueInfo | null {
  if (!dueDate) return null;
  const days = diffDaysLocal(today, dueDate);
  if (days < 0 && !opts.done) {
    const late = -days;
    return { text: `${late} ${plural(late, ['dzień', 'dni', 'dni'])} po terminie`, tone: 'danger', overdue: true };
  }
  if (days === 0) return { text: 'dziś', tone: opts.done ? 'muted' : 'warning', overdue: false };
  if (days === 1) return { text: 'jutro', tone: 'muted', overdue: false };
  if (days === -1) return { text: 'wczoraj', tone: 'muted', overdue: false };
  if (days > 1 && days < 7) return { text: WEEKDAYS[weekday(dueDate)] ?? dueDate, tone: 'muted', overdue: false };
  return { text: formatDateShort(dueDate, new Date(`${today}T12:00:00Z`)), tone: 'muted', overdue: false };
}

/** Klasa koloru terminu (lista, tablica, karta): po terminie czerwony, dziś bursztynowy. */
export function dueToneClass(due: DueInfo | null | undefined): string | undefined {
  if (!due) return undefined;
  if (due.tone === 'danger') return 'text-danger font-medium';
  if (due.tone === 'warning') return 'text-warning font-medium';
  return undefined;
}

/** Szybkie terminy w menu karty zadania. */
export function quickDueOptions(today: string): { label: string; value: string }[] {
  const toSunday = (7 - weekday(today)) % 7;
  const nextMonday = addDaysLocal(today, toSunday + 1);
  return [
    { label: 'Dziś', value: today },
    { label: 'Jutro', value: addDaysLocal(today, 1) },
    { label: 'Przyszły poniedziałek', value: nextMonday },
  ];
}
